var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { usersApi, userGroupsApi } from '@data/rest/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { addQueryClientArrayMember, removeQueryClientArrayMember, updateQueryClientArrayMember } from '@util/query';
function getResourcesAndTarget(queryClient, targetId, queryKey) {
    var resources = queryClient.getQueryData(queryKey);
    var target = resources.find(function (_a) {
        var id = _a.id;
        return id === targetId;
    });
    return [target, __spreadArray([], __read(resources), false)];
}
function removeCachedEntityById(queryClient, targetId, queryKey) {
    var _a;
    var resources = queryClient.getQueryData(queryKey);
    var filtered = (_a = resources.filter(function (_a) {
        var id = _a.id;
        return id !== targetId;
    })) !== null && _a !== void 0 ? _a : [];
    queryClient.setQueryData(queryKey, filtered);
}
/**
 *
 * @returns the list of all users
 */
export function useUsers(options) {
    var data = useQuery(['users'], function () { return usersApi.list(); }, __assign({}, options)).data;
    if (!data) {
        return [];
    }
    return data;
}
export function useUsers2(options) {
    var users = useQuery(['users'], function () { return usersApi.list(); }, __assign({}, options));
    return users;
}
export function useGroups() {
    var data = useQuery(['groups'], function () { return userGroupsApi.list(); }).data;
    if (!data) {
        return [];
    }
    return data;
}
export function useCreateGroupAction() {
    var _this = this;
    var queryClient = useQueryClient();
    var mutation = useMutation(function (userGroup) { return userGroupsApi.create(userGroup); }, {
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['groups']);
                return [2 /*return*/];
            });
        }); },
    });
    return function createGroup(userGroup) {
        mutation.mutate(userGroup);
    };
}
export function useRemoveGroupAction() {
    var _this = this;
    var queryClient = useQueryClient();
    var mutation = useMutation(function (userGroup) { return userGroupsApi.remove(userGroup.id); }, {
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['groups']);
                return [2 /*return*/];
            });
        }); },
    });
    return function removeGroup(userGroup) {
        mutation.mutate(userGroup);
    };
}
export function useUserGroupActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var removeMutation = useMutation(function (id) { return userGroupsApi.remove(id); }, {
        onMutate: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(['groups'])];
                        case 1:
                            _a.sent();
                            removeCachedEntityById(queryClient, id, ['groups']);
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    queryClient.invalidateQueries(['groups']);
                    return [2 /*return*/];
                });
            });
        },
    });
    var createMutation = useMutation(function (name) { return userGroupsApi.create({ name: name }); }, {
        onMutate: function (name) {
            return __awaiter(this, void 0, void 0, function () {
                var groups;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(['groups'])];
                        case 1:
                            _a.sent();
                            groups = queryClient.getQueryData(['groups']);
                            groups && queryClient.setQueryData(['groups'], __spreadArray([{ id: 0, name: name, userIds: [] }], __read(groups), false));
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    queryClient.invalidateQueries(['groups']);
                    return [2 /*return*/];
                });
            });
        },
    });
    var addUserMutation = useMutation(function (data) { return userGroupsApi.addUsers(data.targetId, data.payload); }, {
        onMutate: function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _a, group, groups;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['groups'])];
                    case 1:
                        _b.sent();
                        _a = __read(getResourcesAndTarget(queryClient, data.targetId, [
                            'groups',
                        ]), 2), group = _a[0], groups = _a[1];
                        if (group) {
                            group.userIds = __spreadArray(__spreadArray([], __read(data.payload.userIds), false), __read(group.userIds), false).sort(function (a, b) { return b - a; });
                            queryClient.setQueryData(['groups'], groups);
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['groups']);
                return [2 /*return*/];
            });
        }); },
    });
    var removeUserMutation = useMutation(function (data) { return userGroupsApi.removeUsers(data.targetId, data.payload); }, {
        onMutate: function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _a, group, groups;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['groups'])];
                    case 1:
                        _b.sent();
                        _a = __read(getResourcesAndTarget(queryClient, data.targetId, [
                            'groups',
                        ]), 2), group = _a[0], groups = _a[1];
                        if (group) {
                            group = __assign(__assign({}, group), { userIds: group.userIds.filter(function (id) { return !data.payload.userIds.includes(id); }) });
                            queryClient.setQueryData(['groups'], __spreadArray([], __read(groups), false));
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['groups']);
                return [2 /*return*/];
            });
        }); },
    });
    var mutation = useMutation(function (data) { return userGroupsApi.update(data.id, data.updateData); }, {
        onMutate: function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _a, group, groups;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['groups'])];
                    case 1:
                        _b.sent();
                        _a = __read(getResourcesAndTarget(queryClient, data.id, ['groups']), 2), group = _a[0], groups = _a[1];
                        if (group) {
                            group = __assign(__assign({}, group), data.updateData);
                            queryClient.setQueryData(['groups'], groups);
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['groups']);
                return [2 /*return*/];
            });
        }); },
    });
    return {
        createGroup: function (name) {
            createMutation.mutate(name);
        },
        addUserToGroup: function (userId, groupId) {
            addUserMutation.mutate({ payload: { userIds: [userId] }, targetId: groupId });
        },
        removeUserFromGroup: function (userId, groupId) {
            removeUserMutation.mutate({ payload: { userIds: [userId] }, targetId: groupId });
        },
        updateGroup: function (id, updateData) {
            mutation.mutate({ id: id, updateData: updateData });
        },
        removeGroup: function (id) {
            removeMutation.mutate(id);
        },
    };
}
export function useUserActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var createMutation = useMutation(function (user) { return usersApi.create(user); }, {
        onMutate: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['users'])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function (user) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (user) {
                    addQueryClientArrayMember(queryClient, ['users'], user);
                }
                queryClient.invalidateQueries(['users']);
                return [2 /*return*/];
            });
        }); },
    });
    var updateMutation = useMutation(function (user) { return usersApi.update(user.id, user); }, {
        onMutate: function (user) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['users'])];
                    case 1:
                        _a.sent();
                        updateQueryClientArrayMember(queryClient, ['users'], user);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['users']);
                return [2 /*return*/];
            });
        }); },
    });
    var deleteMutation = useMutation(function (userId) { return usersApi.remove(userId); }, {
        onMutate: function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(['users'])];
                    case 1:
                        _a.sent();
                        removeQueryClientArrayMember(queryClient, ['users'], userId);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(['users']);
                return [2 /*return*/];
            });
        }); },
    });
    return {
        createUser: function createUser(user) {
            createMutation.mutate(user);
        },
        deleteUser: function deleteUser(user) {
            deleteMutation.mutate(user.id);
        },
        updateUser: function editUser(user) {
            updateMutation.mutate(user);
        },
    };
}
